import $ from 'jquery';
import 'bootstrap';
import Slick from 'slick-carousel';

(function ($) {
    $('.js-slide.-testimony').slick({
        'prevArrow': '<button type="button" class="slick-prev" aria-label="next"><svg class="icon"><use xlink:href="#icon-fleche"></use></svg></button>',
        'nextArrow': '<button type="button" class="slick-next" aria-label="previous"><svg class="icon"><use xlink:href="#icon-fleche"></use></svg></button>',
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    'dots': true,
                    'arrows': false
                }
            }
        ]
    });

    $('.js-slide.-properties').slick({
        arrows: false,
        slidesToShow: 3,
        responsive: [
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 550,
                settings: {
                    slidesToShow: 1
                }
            },
        ]
    });

//Shim for :placeholder-shown for edge bug
// Add .placeholder-shown class to the text field elements then value is set

    var placeholderShown = function(e, self) {
            var self = $(self || this),
                shown = 'placeholder-shown',
                hasValue = !!self.val();
            self.toggleClass(shown, !hasValue);
        };


    $(document).ready(function () {
        let $nav = $(".page__header").find('.navbar');
        $nav.toggleClass('scrolled', $(this).scrollTop() > $(".page__header").height());

        if ($('.form-estimate .js-webform-telephone-international').each(function() {
            $(this).val('+352');
            window.intlTelInput(this);
        }));

        $('input').each(function(key, elem) {
            placeholderShown(null, elem);
            $(document).on('keyup', 'input', placeholderShown);
        });
        
        $("a").on('click', function(event) {
        
            // Make sure this.hash has a value before overriding default behavior
            if (this.hash !== "") {
                // Prevent default anchor click behavior
                event.preventDefault();
            
                // Store hash
                var hash = this.hash;
            
                // Using jQuery's animate() method to add smooth page scroll
                // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
                $('html, body').animate({
                    scrollTop: $(hash).offset().top
                }, 800, function(){
                
                    // Add hash (#) to URL when done scrolling (default click behavior)
                    window.location.hash = hash;
                });
            } // End if
        });

    });

    $(document).scroll(function () {
        let $nav = $(".page__header").find('.navbar');
        $nav.toggleClass('scrolled', $(this).scrollTop() > $(".page__header").height());
    });

    $(window).resize(function() {
        $('.js-slide').each(function () {
            $(this).slick('resize');
        });
    });
})($);